const custom_notify_me_btn = document.querySelector("#notify-button-custom");
if(custom_notify_me_btn){
  custom_notify_me_btn.addEventListener("click", function() {
      console.log("ma labna paya wan");
      const closestWrapper = this.closest(".product__info-wrapper");
      if (closestWrapper) {
          const email_btton_nofity = closestWrapper.querySelector(".email-me-button");
            if(email_btton_nofity){
                email_btton_nofity.click();
            }
          console.log(email_btton_nofity);  // You can now manipulate or log this element.
      } else {
          console.log("No closest .product__info-wrapper found");
      }
  });
}